import { EndpointSetting } from "@/constants/app/type";
import { UserState } from "../type";

export const callbackResetPassword: EndpointSetting['caller'] = (
  state: UserState,
  action: any,
  endpointName: any
) => {
  state.reset_password.loading = false;
  state.reset_password.error = null;
  state.reset_password.success = true;
  state.reset_password.data = action.payload;
}